<template>
  <div class="vue-top">
    <div class="top-bar__left">
      <div class="top-notifications" role="group" aria-label="消息通知">
        <div v-for="notice in notifications" :key="notice.type" class="top-notice" :class="`top-notice--${notice.type}`">
          <span class="top-notice__icon" aria-hidden="true">
            <i :class="notice.icon"></i>
          </span>
          <span class="top-notice__label">{{ notice.label }}</span>
          <span class="top-notice__count">{{ notice.count }}</span>
        </div>
      </div>
    </div>
    <div class="top-bar__right">
      <el-button class="name" type="text" @click="goInfo"></el-button>
      <!-- <el-select v-model="value" placeholder="请选择">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select> -->
      <!-- <span>{{ userInfo.userName }}</span> -->
      <span>{{ name }}</span>
      <span @click="logout">
        登出
        <i class="icon-tuichu" style="margin-left: 5px"></i>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  name: "Top",
  data() {
    return {
      name: window.localStorage.getItem("name"),
      channel: window.localStorage.getItem("channel"),
      // 范工在此处替换接口的数据。
      // notifications: [
      //   { type: "message", label: "新消息数量", icon: "el-icon-bell", count: "--" },
      //   { type: "critical", label: "危急值报警消息数量", icon: "el-icon-first-aid-kit", count: 3 },
      //   { type: "emergency", label: "报警与紧急事件数量", icon: "el-icon-bell", count: 2 },
      // ],
      options: [
        {
          value: "",
          label: "所有用户",
        },
        {
          value: "选项1",
          label: "沐广珍",
        },
        {
          value: "选项2",
          label: "姜婷依",
        },
        {
          value: "选项3",
          label: "桑桂秋",
        },
        {
          value: "选项4",
          label: "戴婷婷",
        },
      ],
      value: "",
    };
  },
  filters: {},
  created() {
    console.log("this.$store.state.common", this.$store.state.common);
    console.log("this.$store.state.common.newUserCount", this.$store.state.common.newUserCount);
  },
  mounted() {},
  computed: {
    newUserCount() {
      return (this.$store.state.common && this.$store.state.common.newUserCount) || 0;
    },
    newAlarmCount() {
      return (this.$store.state.common && this.$store.state.common.newAlarmCount) || 0;
    },
    warnCount() {
      return (this.$store.state.common && this.$store.state.common.warnCount) || 0;
    },
    consultCount() {
      return (this.$store.state.common && this.$store.state.common.newConsultCount) || 0;
    },

    notifications() {
      return [
        {
          type: "message",
          label: "新用户数量",
          icon: "el-icon-user",
          count: this.newUserCount || 0,
        },
        {
          type: "critical",
          label: "危急值报警消息数量",
          icon: "el-icon-bell",
          count: this.newAlarmCount || 0,
        },
        {
          type: "emergency",
          label: "报警与紧急事件数量",
          icon: "el-icon-warning",
          count: this.warnCount || 0,
        },
        {
          type: "consult",
          label: "新消息数量",
          icon: "el-icon-chat-dot-square",
          count: this.consultCount || 0,
        },
      ];
    },
  },
  methods: {
    goInfo() {
      this.$router.push("/");
    },

    logout() {
      this.$confirm("退出系统, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          window.localStorage.clear();
          this.$router.push({ path: "/login" });
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.vue-top {
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
  height: 65px;
  padding: 0 12px;
  border-bottom: 1px solid #e9edf3;
}

.top-bar__left {
  position: static;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  height: 100%;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: #dce5ef transparent;

  &::-webkit-scrollbar {
    height: 3px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #dce5ef;
  }
}

.top-notifications {
  display: flex;
  align-items: center;
  gap: 20px;
}

.top-notice {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 14px;
  height: 42px;
  padding: 0 10px;
  border: 1px solid;
  border-radius: 8px;
  box-sizing: border-box;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border: 1px solid;
    border-radius: 7px;
    box-sizing: border-box;

    i {
      font-size: 23px;
      line-height: 1;
    }
  }

  &__label {
    flex: 1;
    color: #454f5e;
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
  }

  &__count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    min-width: 32px;
    height: 26px;
    padding: 0 8px;
    border-radius: 14px;
    box-sizing: border-box;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
  }

  &--message {
    width: 214px;
    border-color: #c9dfff;
    background-color: #f4f8ff;

    .top-notice__icon {
      border-color: #c9dfff;
      background-color: #eaf3ff;
      color: #1677ff;
    }

    .top-notice__count {
      background-color: #1677ff;
    }
  }

  &--critical {
    width: 246px;
    border-color: #ffd3d7;
    background-color: #fff6f6;

    .top-notice__icon {
      border-color: #ffd7db;
      background-color: #fff0f1;
      color: #f43e4f;
    }

    .top-notice__count {
      background-color: #f43e4f;
    }
  }

  &--emergency {
    width: 268px;
    border-color: #ffe4c4;
    background-color: #fffaf2;

    .top-notice__icon {
      border-color: #ffe3bd;
      background-color: #fff3e3;
      color: #ef861c;
    }

    .top-notice__count {
      background-color: #ef861c;
    }
  }

  &--consult {
    width: 268px;
    border-color: #c6ece8;
    background-color: #f2fbfa;

    .top-notice__icon {
      border-color: #c9ede9;
      background-color: #e6f8f5;
      color: #13a8a8;
    }

    .top-notice__count {
      background-color: #13a8a8;
    }
  }
}

.top-bar__right {
  position: static;
  flex-shrink: 0;
  height: 100%;

  span {
    font-size: 15px;
    margin-right: 1vw;
  }
}

@media screen and (max-width: 1200px) {
  .vue-top {
    gap: 12px;
  }

  .top-notifications {
    gap: 8px;
  }

  .top-notice {
    gap: 8px;

    &__icon {
      width: 28px;
      height: 28px;

      i {
        font-size: 21px;
      }
    }

    &__label {
      font-size: 13px;
    }

    &__count {
      min-width: 28px;
      font-size: 14px;
    }

    &--message {
      width: 170px;
    }

    &--critical,
    &--emergency {
      width: 220px;
    }
  }
}
</style>
